var rnr = new function () {
	this.navClick = function () {
	}
};
$(document).ready(function () {
	AOS.init({
		startEvent: 'DOMContentLoaded',
		once: true,
		duration: 750
	});

	$('.site-header__nav-button').click(function () {
		$(this).toggleClass('active').find('i').toggleClass('fa-times');
		if ($(this).hasClass('active')) {
			$('body').addClass('menu-open');
			$('.site-header__nav').addClass('active');
		} else {
			$('body').removeClass('menu-open');
			$('.site-header__nav').removeClass('active');
		}
	});

	$('a[href*="#"]:not([href="#"].back-to-top)').click(function (e) {
		// use prevent default function
		e.preventDefault()
		var target = $(this.hash);
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - 50
			}, 1000);
		}
	});

	if(!$('body.wp-admin').length) {
		$('#tokenFilter option').each(function(e) {
			var value = $(this).val();
			if(value !== 'All') {
				if(!$('#'+value+'.wp-block-table').length) {
					$('#tokenFilter option[value="'+value+'"]').remove();
				}
			}
		});
	}

	$('table[id^=datatable]').each(function(e) {
		$(this).tablesorter({ sortList: [[5,0]], sortReset: true });
	});

	$('#tokenFilter').on('change', function(e) {
		var value = $(this).val();
		if(value == 'All') {
			$('.wp-block-table').show();
			return;
		}
		$('.wp-block-table').hide();
		$('.wp-block-table[id="'+value+'"]').show();
	});

	$('.freeroll-toggle input').on('click', function() {
		var $table = $(this).closest('.wp-block-table'),
			checked = false;
		if($(this).is(':checked')) {
			checked = true;
		}

		if(checked) {
			$table.find('tbody > tr[data-freeroll=0]').addClass('hide');
		} else {
			$table.find('tbody > tr').removeClass('hide');
		}

	});

	$('#timezoneSelect option').each(function(e) {
		var timeZone = $(this).val();
		$(this).html(moment().tz(timeZone).zoneAbbr() + moment().tz(timeZone).format('Z'));
	});

	$(document).on('change', '#timezoneSelect', function(e) {
		var timeZone = $(this).val();

		$(this).closest('table').find('td.date').each(function() {
			var time = $(this).data('date');

			var m = moment.utc(time, "YYYY-MM-DD h A"); // parse input as UTC
	
			$(this).html(changeTimeZone(m, timeZone));
		});

		$(this).closest('table').find('th.date .zone').html('(' + moment().tz(timeZone).zoneAbbr() + moment().tz(timeZone).format('Z') + ')');
	});

	function changeTimeZone(date, tz) {
		return date.clone().tz(tz).format("MMMM Do YYYY, h a")
	}
});